export default __webpack_public_path__ + "static/media/hero-example.3349ce45.png";